import { create } from 'zustand'
import { env } from '@/lib/env'

interface TenantState {
  tenantId: string
}

/**
 * Which tenant the operator is scoping into. Pulse v1 has no tenant
 * switcher — the UI is single-org (Boldfit). We keep this store so the
 * Vision client + directory queries (channels, vendors) have a single
 * source of truth for the tenant code, but there is no user-facing
 * affordance to change it. The value is fixed to `env.VITE_DEFAULT_TENANT`
 * at boot and never mutated at runtime.
 */
export const useTenantStore = create<TenantState>()(() => ({
  tenantId: env.VITE_DEFAULT_TENANT,
}))
